function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
var ModTemplate = require('../../lib/templates/modtemplate');
var SaitoHeader = require('../../lib/saito/ui/saito-header/saito-header');
var _require = require('./lib/document'),
  emptyDocument = _require.emptyDocument,
  isPdf = _require.isPdf,
  hasPdf = _require.hasPdf,
  revoke = _require.revoke,
  openPdfs = _require.openPdfs,
  hydrate = _require.hydrate,
  addUser = _require.addUser,
  stripSignatures = _require.stripSignatures;
var _require2 = require('./lib/transaction'),
  looksLikeWebTransaction = _require2.looksLikeWebTransaction,
  createPrepareTransaction = _require2.createPrepareTransaction,
  readPrepareTransaction = _require2.readPrepareTransaction,
  downloadBytes = _require2.downloadBytes;
var _require3 = require('./lib/zip'),
  createZip = _require3.createZip,
  readZip = _require3.readZip,
  looksLikeZip = _require3.looksLikeZip,
  isZipFile = _require3.isZipFile;
var Main = require('./lib/ui/main');
var HomePage = require('./index');
var _require4 = require('./lib/auth'),
  verifyEmail = _require4.verifyEmail,
  myKeychainEmail = _require4.myKeychainEmail,
  rememberVerifiedEmails = _require4.rememberVerifiedEmails,
  documentUnchanged = _require4.documentUnchanged,
  createCreatorProof = _require4.createCreatorProof,
  verifyCreatorProof = _require4.verifyCreatorProof,
  finalizeDocument = _require4.finalizeDocument,
  verifyFinalization = _require4.verifyFinalization,
  signingConfigurationError = _require4.signingConfigurationError;
var _require5 = require('./lib/draft'),
  loadDraft = _require5.loadDraft,
  clearDraft = _require5.clearDraft;
var ARCHIVE_README = 'This is a SaitoSign zip archive. To sign this document, visit sato.io/SaitoSign, and copy the zip file or the SaitoSign file into the UI and follow the instructions.\n';
var SaitoSign = /*#__PURE__*/function (_ModTemplate) {
  function SaitoSign(app) {
    var _this;
    _classCallCheck(this, SaitoSign);
    _this = _callSuper(this, SaitoSign, [app]);
    _this.name = 'SaitoSign';
    _this.slug = 'saitosign';
    _this.description = 'Create, sign, and exchange documents with cryptographic proof.';
    _this.categories = 'Utilities Productivity';
    _this.status = 'beta';
    _this["class"] = 'app';
    _this.icon = 'fa-solid fa-file-signature';
    _this.styles = ['/saitosign/style.css'];
    _this.dev = 1;
    _this.document = emptyDocument();
    _this.header = null;
    _this.main = new Main(app, _this);
    return _this;
  }
  _inherits(SaitoSign, _ModTemplate);
  return _createClass(SaitoSign, [{
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(app) {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return _superPropGet(SaitoSign, "initialize", this, 3)([app]);
            case 1:
              if (!this.browser_active) {
                _context.n = 3;
                break;
              }
              this.header = new SaitoHeader(app, this);
              _context.n = 2;
              return this.header.initialize(app);
            case 2:
              _context.n = 3;
              return this.openSavedDocument();
            case 3:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function initialize(_x) {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }()
  }, {
    key: "openSavedDocument",
    value: function () {
      var _openSavedDocument = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var code, saved, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              code = this.app.browser.returnURLParameter('code');
              if (!(!code || hasPdf(this.document))) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              _context2.n = 2;
              return loadDraft();
            case 2:
              saved = _context2.v;
              if (!(!saved || saved.code !== code || !saved.document || !this.signatureVerifies(saved.document, code))) {
                _context2.n = 3;
                break;
              }
              return _context2.a(2);
            case 3:
              _context2.p = 3;
              _context2.n = 4;
              return hydrate(saved.document);
            case 4:
              this.document = _context2.v;
              if (!(this.document.creator && !verifyCreatorProof(this.app, this.document))) {
                _context2.n = 5;
                break;
              }
              throw new Error('Creator identity could not be verified.');
            case 5:
              if (!(this.document.finalized && !verifyFinalization(this.app, this.document))) {
                _context2.n = 6;
                break;
              }
              throw new Error('Finalized document signature is invalid.');
            case 6:
              rememberVerifiedEmails(this.app, this.document);
              _context2.n = 8;
              break;
            case 7:
              _context2.p = 7;
              _t = _context2.v;
              this.document = emptyDocument();
            case 8:
              return _context2.a(2);
          }
        }, _callee2, this, [[3, 7]]);
      }));
      function openSavedDocument() {
        return _openSavedDocument.apply(this, arguments);
      }
      return openSavedDocument;
    }()
  }, {
    key: "signatureVerifies",
    value: function signatureVerifies(record, signature) {
      var users = Array.isArray(record === null || record === void 0 ? void 0 : record.users) ? record.users : [];
      var _iterator = _createForOfIteratorHelper(users),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var user = _step.value;
          var entries = Array.isArray(user.verifications) ? user.verifications : [];
          var _iterator2 = _createForOfIteratorHelper(entries),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var entry = _step2.value;
              if (entry.signature !== signature || !entry.message || !entry.publickey) {
                continue;
              }
              if (this.app.crypto.verifyMessage(entry.message, entry.signature, entry.publickey)) {
                return true;
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return false;
    }
  }, {
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (!(!this.app.BROWSER || !this.browser_active)) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2);
            case 1:
              if (this.header) {
                _context3.n = 2;
                break;
              }
              this.header = new SaitoHeader(this.app, this);
              _context3.n = 2;
              return this.header.initialize(this.app);
            case 2:
              this.addComponent(this.header);
              _context3.n = 3;
              return _superPropGet(SaitoSign, "render", this, 3)([]);
            case 3:
              this.main.render();
            case 4:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "importFile",
    value: function () {
      var _importFile = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(file) {
        var header, text, _t2, _t3, _t4, _t5;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              header = new Uint8Array();
              _context4.p = 1;
              _t2 = Uint8Array;
              _context4.n = 2;
              return file.slice(0, 4).arrayBuffer();
            case 2:
              _t3 = _context4.v;
              header = new _t2(_t3);
              _context4.n = 4;
              break;
            case 3:
              _context4.p = 3;
              _t4 = _context4.v;
              header = new Uint8Array();
            case 4:
              if (!(isZipFile(file) || looksLikeZip(header))) {
                _context4.n = 5;
                break;
              }
              return _context4.a(2, this.importZip(file));
            case 5:
              text = '';
              _context4.p = 6;
              _context4.n = 7;
              return file.text();
            case 7:
              text = _context4.v;
              _context4.n = 9;
              break;
            case 8:
              _context4.p = 8;
              _t5 = _context4.v;
              text = '';
            case 9:
              if (!looksLikeWebTransaction(text)) {
                _context4.n = 10;
                break;
              }
              return _context4.a(2, this.openSaitoSignText(text));
            case 10:
              if (!(isPdf(file) || text.slice(0, 1024).includes('%PDF'))) {
                _context4.n = 11;
                break;
              }
              return _context4.a(2, this.importPdfs([file]));
            case 11:
              this.main.fail('Choose a PDF or a SaitoSign transaction.');
            case 12:
              return _context4.a(2);
          }
        }, _callee4, this, [[6, 8], [1, 3]]);
      }));
      function importFile(_x2) {
        return _importFile.apply(this, arguments);
      }
      return importFile;
    }()
  }, {
    key: "importZip",
    value: function () {
      var _importZip = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(file) {
        var bytes, entries, text, _t6, _t7, _t8;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              _context5.p = 0;
              _t6 = Uint8Array;
              _context5.n = 1;
              return file.arrayBuffer();
            case 1:
              _t7 = _context5.v;
              bytes = new _t6(_t7);
              if (looksLikeZip(bytes)) {
                _context5.n = 2;
                break;
              }
              this.main.fail('That ZIP archive could not be read.');
              return _context5.a(2);
            case 2:
              _context5.n = 3;
              return readZip(bytes);
            case 3:
              entries = _context5.v;
              text = saitosignTextFromZip(entries);
              if (text) {
                _context5.n = 4;
                break;
              }
              this.main.fail('That ZIP archive does not contain a SaitoSign document.');
              return _context5.a(2);
            case 4:
              return _context5.a(2, this.openSaitoSignText(text));
            case 5:
              _context5.p = 5;
              _t8 = _context5.v;
              this.main.fail((_t8 === null || _t8 === void 0 ? void 0 : _t8.message) || 'That ZIP archive could not be read.');
            case 6:
              return _context5.a(2);
          }
        }, _callee5, this, [[0, 5]]);
      }));
      function importZip(_x3) {
        return _importZip.apply(this, arguments);
      }
      return importZip;
    }()
  }, {
    key: "openSaitoSignText",
    value: function () {
      var _openSaitoSignText = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(text) {
        var data, changed, _err$message, _err$message2, known, integrityError, _t9, _t0;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              _context6.p = 0;
              data = readPrepareTransaction(this.app, text);
              if (!(data.finalized && !verifyFinalization(this.app, data))) {
                _context6.n = 1;
                break;
              }
              throw new Error('The creator signature for this finalized document is invalid.');
            case 1:
              changed = !documentUnchanged(this.app, data);
              if (changed) {
                stripSignatures(data);
              }
              _t9 = this;
              _context6.n = 2;
              return hydrate(data);
            case 2:
              _t9.useDocument.call(_t9, _context6.v);
              if (changed && typeof salert === 'function') {
                salert('This document has changed. Signatures have been removed and signing must begin again.');
              }
              _context6.n = 4;
              break;
            case 3:
              _context6.p = 3;
              _t0 = _context6.v;
              known = (_t0 === null || _t0 === void 0 ? void 0 : _t0.message) === 'That file is not a SaitoSign transaction.';
              integrityError = (_t0 === null || _t0 === void 0 || (_err$message = _t0.message) === null || _err$message === void 0 ? void 0 : _err$message.includes('creator signature')) || (_t0 === null || _t0 === void 0 || (_err$message2 = _t0.message) === null || _err$message2 === void 0 ? void 0 : _err$message2.includes('creator identity'));
              this.main.fail(known || integrityError ? _t0.message : 'That SaitoSign transaction could not be read.');
            case 4:
              return _context6.a(2);
          }
        }, _callee6, this, [[0, 3]]);
      }));
      function openSaitoSignText(_x4) {
        return _openSaitoSignText.apply(this, arguments);
      }
      return openSaitoSignText;
    }()
  }, {
    key: "importPdf",
    value: function () {
      var _importPdf = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(file) {
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              return _context7.a(2, this.importPdfs([file]));
          }
        }, _callee7, this);
      }));
      function importPdf(_x5) {
        return _importPdf.apply(this, arguments);
      }
      return importPdf;
    }()
  }, {
    key: "importPdfs",
    value: function () {
      var _importPdfs = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(files) {
        var list, _iterator3, _step3, file, next, _this$app$wallet, mine, index, _t1, _t10, _t11, _t12;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.p = _context8.n) {
            case 0:
              list = Array.isArray(files) ? files.filter(Boolean) : [];
              if (list.length) {
                _context8.n = 1;
                break;
              }
              this.main.fail('Choose a PDF or a SaitoSign transaction.');
              return _context8.a(2);
            case 1:
              _iterator3 = _createForOfIteratorHelper(list);
              _context8.p = 2;
              _iterator3.s();
            case 3:
              if ((_step3 = _iterator3.n()).done) {
                _context8.n = 7;
                break;
              }
              file = _step3.value;
              _t1 = !isPdf(file);
              if (!_t1) {
                _context8.n = 5;
                break;
              }
              _context8.n = 4;
              return pdfBytes(file);
            case 4:
              _t1 = !_context8.v;
            case 5:
              if (!_t1) {
                _context8.n = 6;
                break;
              }
              this.main.fail('Choose a PDF or a SaitoSign transaction.');
              return _context8.a(2);
            case 6:
              _context8.n = 3;
              break;
            case 7:
              _context8.n = 9;
              break;
            case 8:
              _context8.p = 8;
              _t10 = _context8.v;
              _iterator3.e(_t10);
            case 9:
              _context8.p = 9;
              _iterator3.f();
              return _context8.f(9);
            case 10:
              _context8.p = 10;
              _context8.n = 11;
              return openPdfs(list);
            case 11:
              next = _context8.v;
              next.creator = String(((_this$app$wallet = this.app.wallet) === null || _this$app$wallet === void 0 ? void 0 : _this$app$wallet.publicKey) || '').trim();
              _context8.n = 12;
              return createCreatorProof(this.app, next, next.creator);
            case 12:
              _context8.n = 14;
              break;
            case 13:
              _context8.p = 13;
              _t11 = _context8.v;
              this.main.fail('That PDF could not be read.');
              return _context8.a(2);
            case 14:
              _context8.p = 14;
              _context8.n = 15;
              return clearDraft();
            case 15:
              _context8.n = 17;
              break;
            case 16:
              _context8.p = 16;
              _t12 = _context8.v;
            case 17:
              if (!next.users.length) {
                mine = myKeychainEmail(this.app);
                if (mine) {
                  index = addUser(next, mine.name, next.creator);
                  next.users[index].email = mine.email;
                  next.users[index].publickey = mine.publickey;
                }
              }
              this.useDocument(next);
              if (this.main && this.main.workspace && this.main.workspace.publish) {
                this.main.workspace.publish.reset();
              }
            case 18:
              return _context8.a(2);
          }
        }, _callee8, this, [[14, 16], [10, 13], [2, 8, 9, 10]]);
      }));
      function importPdfs(_x6) {
        return _importPdfs.apply(this, arguments);
      }
      return importPdfs;
    }()
  }, {
    key: "exportDocument",
    value: function () {
      var _exportDocument = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var options,
          document,
          _this$app$wallet2,
          walletKey,
          problem,
          finalized,
          tx,
          base,
          saitosignName,
          saitosignBytes,
          files,
          _args9 = arguments,
          _t13;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.p = _context9.n) {
            case 0:
              options = _args9.length > 0 && _args9[0] !== undefined ? _args9[0] : {};
              document = this.document;
              if (!(!hasPdf(document) || !options.draft && !document.edited)) {
                _context9.n = 1;
                break;
              }
              return _context9.a(2, false);
            case 1:
              _context9.p = 1;
              if (!(!options.draft && !document.finalized)) {
                _context9.n = 7;
                break;
              }
              walletKey = String(((_this$app$wallet2 = this.app.wallet) === null || _this$app$wallet2 === void 0 ? void 0 : _this$app$wallet2.publicKey) || '').trim();
              if (!(!walletKey || !document.creator || walletKey !== document.creator || !verifyCreatorProof(this.app, document))) {
                _context9.n = 2;
                break;
              }
              this.main.fail('Only the document creator can finalize and export this document.');
              return _context9.a(2, false);
            case 2:
              if ((document.actions || []).length) {
                _context9.n = 3;
                break;
              }
              this.main.fail('Add at least one action before finalizing this document.');
              return _context9.a(2, false);
            case 3:
              problem = signingConfigurationError(document);
              if (!problem) {
                _context9.n = 4;
                break;
              }
              this.main.fail(problem);
              return _context9.a(2, false);
            case 4:
              _context9.n = 5;
              return finalizeDocument(this.app, document, walletKey);
            case 5:
              finalized = _context9.v;
              if (finalized) {
                _context9.n = 6;
                break;
              }
              this.main.fail('This document could not be finalized.');
              return _context9.a(2, false);
            case 6:
              _context9.n = 8;
              break;
            case 7:
              if (!(!options.draft && (!verifyCreatorProof(this.app, document) || !verifyFinalization(this.app, document)))) {
                _context9.n = 8;
                break;
              }
              this.main.fail('The finalized document creator signature is invalid.');
              return _context9.a(2, false);
            case 8:
              _context9.n = 9;
              return createPrepareTransaction(this.app, document);
            case 9:
              tx = _context9.v;
              base = String(document.document.name || 'document.pdf').replace(/\.pdf$/i, '') || 'document';
              saitosignName = "".concat(base, ".saitosign");
              saitosignBytes = new TextEncoder().encode(tx.serialize_to_web(this.app));
              files = [{
                name: saitosignName,
                data: saitosignBytes
              }, {
                name: 'readme.txt',
                data: new TextEncoder().encode(ARCHIVE_README)
              }].concat(_toConsumableArray(pdfZipEntries(document)));
              downloadBytes(createZip(files), "".concat(base, ".zip"), 'application/zip');
              return _context9.a(2, true);
            case 10:
              _context9.p = 10;
              _t13 = _context9.v;
              this.main.fail('That document could not be exported.');
              return _context9.a(2, false);
          }
        }, _callee9, this, [[1, 10]]);
      }));
      function exportDocument() {
        return _exportDocument.apply(this, arguments);
      }
      return exportDocument;
    }()
  }, {
    key: "useDocument",
    value: function useDocument(next) {
      var previous = this.document;
      if (previous && previous !== next) {
        revoke(previous);
      }
      this.document = next;
      rememberVerifiedEmails(this.app, next);
      this.main.showWorkspace();
    }
  }, {
    key: "handlePeerTransaction",
    value: function () {
      var _handlePeerTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(app) {
        var _txmsg;
        var tx,
          peer,
          mycallback,
          txmsg,
          result,
          _args0 = arguments,
          _t14;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.p = _context0.n) {
            case 0:
              tx = _args0.length > 1 && _args0[1] !== undefined ? _args0[1] : null;
              peer = _args0.length > 2 ? _args0[2] : undefined;
              mycallback = _args0.length > 3 && _args0[3] !== undefined ? _args0[3] : null;
              if (tx) {
                _context0.n = 1;
                break;
              }
              return _context0.a(2, 0);
            case 1:
              _context0.p = 1;
              txmsg = tx.returnMessage();
              _context0.n = 3;
              break;
            case 2:
              _context0.p = 2;
              _t14 = _context0.v;
              return _context0.a(2, 0);
            case 3:
              if (!(((_txmsg = txmsg) === null || _txmsg === void 0 ? void 0 : _txmsg.request) !== 'saitosign verify email')) {
                _context0.n = 4;
                break;
              }
              return _context0.a(2, _superPropGet(SaitoSign, "handlePeerTransaction", this, 3)([app, tx, peer, mycallback]));
            case 4:
              _context0.n = 5;
              return this.receiveVerifyEmail(txmsg.data || {});
            case 5:
              result = _context0.v;
              if (mycallback) {
                mycallback(result);
              }
              return _context0.a(2, 1);
          }
        }, _callee0, this, [[1, 2]]);
      }));
      function handlePeerTransaction(_x7) {
        return _handlePeerTransaction.apply(this, arguments);
      }
      return handlePeerTransaction;
    }()
  }, {
    key: "receiveVerifyEmail",
    value: function () {
      var _receiveVerifyEmail = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(data) {
        var email, publickey, mail, canSend, message, signature, serverkey, proof, _serverkey, _t15, _t16, _t17, _t18, _t19;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.p = _context1.n) {
            case 0:
              email = String(data.email || '').trim();
              publickey = String(data.publickey || data.publicKey || '').trim();
              mail = this.app.modules.returnModule('MailRelay');
              canSend = !this.app.BROWSER && mail && Array.isArray(mail.services) && mail.services.length > 0;
              if (!(!email || !publickey)) {
                _context1.n = 1;
                break;
              }
              return _context1.a(2, {
                success: false
              });
            case 1:
              if (canSend) {
                _context1.n = 6;
                break;
              }
              if (this.dev) {
                _context1.n = 2;
                break;
              }
              return _context1.a(2, {
                success: false
              });
            case 2:
              message = "Request received for verification of email ".concat(email, " with publickey ").concat(publickey);
              _t15 = this.app.crypto;
              _t16 = message;
              _context1.n = 3;
              return this.app.wallet.getPrivateKey();
            case 3:
              signature = _t15.signMessage.call(_t15, _t16, _context1.v);
              _t17 = this.publicKey;
              if (_t17) {
                _context1.n = 5;
                break;
              }
              _context1.n = 4;
              return this.app.wallet.getPublicKey();
            case 4:
              _t17 = _context1.v;
            case 5:
              serverkey = _t17;
              return _context1.a(2, {
                success: false,
                error: signature,
                publickey: serverkey
              });
            case 6:
              _context1.p = 6;
              _context1.n = 7;
              return verifyEmail(this.app, email, publickey);
            case 7:
              proof = _context1.v;
              _t18 = this.publicKey;
              if (_t18) {
                _context1.n = 9;
                break;
              }
              _context1.n = 8;
              return this.app.wallet.getPublicKey();
            case 8:
              _t18 = _context1.v;
            case 9:
              _serverkey = _t18;
              return _context1.a(2, {
                success: true,
                publickey: _serverkey,
                message: proof.message,
                signature: proof.signature
              });
            case 10:
              _context1.p = 10;
              _t19 = _context1.v;
              return _context1.a(2, {
                success: false
              });
          }
        }, _callee1, this, [[6, 10]]);
      }));
      function receiveVerifyEmail(_x8) {
        return _receiveVerifyEmail.apply(this, arguments);
      }
      return receiveVerifyEmail;
    }()
  }, {
    key: "respondTo",
    value: function respondTo(type) {
      if (type === 'saito-header' && !this.browser_active) {
        return [{
          text: 'SaitoSign',
          icon: this.icon,
          rank: 45,
          type: 'navigation',
          navigation: '/saitosign',
          callback: function callback() {
            navigateWindow('/saitosign');
          }
        }];
      }
      return _superPropGet(SaitoSign, "respondTo", this, 3)([type]);
    }
  }, {
    key: "webServer",
    value: function webServer(app, expressapp, express) {
      var webdir = "".concat(__dirname, "/web");
      var slug = encodeURI(this.returnSlug());
      var mod_self = this;
      expressapp.get(['/' + slug, '/' + slug + '/'], function (req, res) {
        res.setHeader('Content-type', 'text/html');
        res.charset = 'UTF-8';
        res.send(HomePage(app, mod_self, app.build_number));
      });
      expressapp.use('/' + slug, express["static"](webdir));
    }
  }]);
}(ModTemplate);
function pdfBytes(_x9) {
  return _pdfBytes.apply(this, arguments);
}
function _pdfBytes() {
  _pdfBytes = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(file) {
    var text, _t20, _t21, _t22, _t23;
    return _regenerator().w(function (_context10) {
      while (1) switch (_context10.p = _context10.n) {
        case 0:
          _context10.p = 0;
          _t20 = new TextDecoder('latin1');
          _t21 = Uint8Array;
          _context10.n = 1;
          return file.arrayBuffer();
        case 1:
          _t22 = _context10.v;
          text = _t20.decode.call(_t20, new _t21(_t22));
          return _context10.a(2, text.slice(0, 1024).includes('%PDF'));
        case 2:
          _context10.p = 2;
          _t23 = _context10.v;
          return _context10.a(2, false);
      }
    }, _callee10, null, [[0, 2]]);
  }));
  return _pdfBytes.apply(this, arguments);
}
function pdfZipEntries(record) {
  var _record$document;
  var used = new Set();
  var list = Array.isArray(record === null || record === void 0 || (_record$document = record.document) === null || _record$document === void 0 ? void 0 : _record$document.pdf) ? record.document.pdf : [];
  return list.map(function (entry, index) {
    var data = Uint8Array.from(Buffer.from(String((entry === null || entry === void 0 ? void 0 : entry.pdf) || ''), 'base64'));
    return {
      name: "PDFs/".concat(safePdfFilename(entry === null || entry === void 0 ? void 0 : entry.name, index, used)),
      data: data
    };
  });
}
function safePdfFilename(original, index, used) {
  var base = String(original || '').replace(/\\/g, '/').split('/').pop().trim().replace(/[^\w.\- ()[\]]+/g, '_').replace(/^\.+/, '');
  if (!base) {
    base = "document-".concat(index + 1, ".pdf");
  }
  if (!/\.pdf$/i.test(base)) {
    base = "".concat(base, ".pdf");
  }
  var name = base;
  var suffix = 2;
  while (used.has(name.toLowerCase())) {
    name = "".concat(base.replace(/\.pdf$/i, ''), "-").concat(suffix, ".pdf");
    suffix += 1;
  }
  used.add(name.toLowerCase());
  return name;
}
function saitosignTextFromZip(entries) {
  var candidates = [];
  var seen = new Set();
  (entries || []).forEach(function (entry) {
    var path = zipEntryPath(entry === null || entry === void 0 ? void 0 : entry.name);
    if (!path) {
      return;
    }
    var parts = path.split('/');
    if (parts[0].toLowerCase() === 'pdfs') {
      return;
    }
    var base = parts[parts.length - 1] || '';
    if (/^readme\.txt$/i.test(base)) {
      return;
    }
    var text = new TextDecoder().decode(entry.data).trim();
    if (!/\.saitosign$/i.test(base) && !looksLikeWebTransaction(text)) {
      return;
    }
    var key = path.toLowerCase();
    if (seen.has(key)) {
      return;
    }
    seen.add(key);
    candidates.push({
      path: path,
      text: text
    });
  });
  if (candidates.length > 1) {
    throw new Error('That ZIP archive contains more than one SaitoSign document.');
  }
  if (!candidates.length) {
    return '';
  }
  return candidates[0].text;
}
function zipEntryPath(name) {
  var parts = String(name || '').replace(/\\/g, '/').split('/').filter(function (part) {
    return part && part !== '.';
  });
  if (!parts.length || parts.some(function (part) {
    return part === '..';
  })) {
    return '';
  }
  return parts.join('/');
}
module.exports = SaitoSign;